import { render, staticRenderFns } from "./PlayersDisplay.vue?vue&type=template&id=ee137f52&scoped=true&"
import script from "./PlayersDisplay.vue?vue&type=script&lang=js&"
export * from "./PlayersDisplay.vue?vue&type=script&lang=js&"
import style0 from "./PlayersDisplay.vue?vue&type=style&index=0&id=ee137f52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee137f52",
  null
  
)

export default component.exports